const appVersion = "pondlogs-0.1.0";

const config = {
  DEV: {
    APP_VERSION: appVersion,
    AUTH_KEY_NAME: "dev-" + appVersion,
    GOOGLE_MAPS_API_KEY: "AIzaSyBAtIFdSS1jFpEt0lLAfnHiq5Q0koi_b5I",
    BK_APP_URL:
      process.env.VUE_APP_BK_APP_URL || "https://dev-user-api.eruvaka.dev/1.0",
    BK_ADMIN_URL:
      process.env.VUE_APP_BK_ADMIN_URL ||
      "https://dev-admin-api.eruvaka.dev/1.0",
    BK_DEALER_URL:
      process.env.VUE_APP_BK_DEALER_URL ||
      "https://dev-admin-api.eruvaka.dev/1.0",
      BK_ACCOUNT_URL:
      process.env.VUE_APP_BK_DEALER_URL ||
      "https://dev-admin-api.eruvaka.dev/1.0",

    VUE_APP_STAGE: process.env.VUE_APP_STAGE || "DEV",
  },
  STATING: {
    APP_VERSION: appVersion,
    AUTH_KEY_NAME: "stating-" + appVersion,
    GOOGLE_MAPS_API_KEY: "AIzaSyBAtIFdSS1jFpEt0lLAfnHiq5Q0koi_b5I",
    BK_APP_URL:
      process.env.VUE_APP_BK_APP_URL || "https://api.eruvaka.space/1.0",
    BK_ADMIN_URL:
      process.env.VUE_APP_BK_ADMIN_URL ||
      "https://dev-admin-api.eruvaka.dev/1.0",

    BK_DEALER_URL:
      process.env.VUE_APP_BK_DEALER_URL ||
      "https://dev-user-api.eruvaka.dev/1.0",
      BK_ACCOUNT_URL:
      process.env.VUE_APP_BK_DEALER_URL ||
      "https://dev-admin-api.eruvaka.dev/1.0",

    VUE_APP_STAGE: process.env.VUE_APP_STAGE || "STATING",
  },
  PROD: {
    APP_VERSION: appVersion,
    AUTH_KEY_NAME: "prod-" + appVersion,
    GOOGLE_MAPS_API_KEY: "AIzaSyBAtIFdSS1jFpEt0lLAfnHiq5Q0koi_b5I",
    BK_APP_URL: process.env.VUE_APP_BK_APP_URL || "https://api.eruvaka.com/1.0",
    BK_ADMIN_URL:
      process.env.VUE_APP_BK_ADMIN_URL ||
      "https://dev-admin-api.eruvaka.dev/1.0",
    BK_DEALER_URL:
      process.env.VUE_APP_BK_DEALER_URL ||
      "https://dev-user-api.eruvaka.dev/1.0",
      BK_ACCOUNT_URL:
      process.env.VUE_APP_BK_DEALER_URL ||
      "https://dev-admin-api.eruvaka.dev/1.0",
    VUE_APP_STAGE: process.env.VUE_APP_STAGE || "PROD",
  },
  BETA: {
    APP_VERSION: appVersion,
    AUTH_KEY_NAME: "beta-" + appVersion,
    GOOGLE_MAPS_API_KEY: "AIzaSyBAtIFdSS1jFpEt0lLAfnHiq5Q0koi_b5I",
    BK_APP_URL:
      process.env.VUE_APP_BK_APP_URL || "https://beta-user-api.eruvaka.dev/1.0",
    BK_ADMIN_URL:
      process.env.VUE_APP_BK_ADMIN_URL ||
      "https://beta-admin-api.eruvaka.dev/1.0",
    BK_DEALER_URL:
      process.env.VUE_APP_BK_DEALER_URL ||
      "https://beta-admin-api.eruvaka.dev/1.0",
      BK_ACCOUNT_URL:
      process.env.VUE_APP_BK_DEALER_URL ||
      "https://dev-admin-api.eruvaka.dev/1.0",
    VUE_APP_STAGE: process.env.VUE_APP_STAGE || "BETA",
  },
};

const env =
  process.env && process.env.VUE_APP_STAGE ? process.env.VUE_APP_STAGE : "DEV";
export default config[env];
